// JQuery and moment are made globally available in webpack mix file


import 'select2/dist/js/select2.full';
import 'moment-business';
import 'moment-business-days';
import '../../legacy-plugins/bootstrap-3.3.5-dist/js/bootstrap.min';
import '../../legacy-plugins/vitalets-bootstrap-datepicker-c7af15b/js/bootstrap-datepicker';
// import 'eonasdan-bootstrap-datetimepicker';// we are calling this one in through cdn, it doesn't attach to global JQuery properly though webpack
import forceCloseModal from "../core/utils/force-close-modal"; // need to be at the top of this file

import 'magnific-popup';
import 'tether';
import 'chosen-js';
import 'datatables.net';
// import 'datatables.net-bs';
import 'datatables.net-dt';
import 'datatables.net-responsive';
import 'stacktable.js';
import 'imagesloaded';
import 'masonry-layout/dist/masonry.pkgd';


// lesser used plugins - add checks before load if script file is in footer
import 'jquery-collapse/src/jquery.collapse';
import 'spectrum-colorpicker';
import '../../legacy-plugins/jquery.populate-master/jquery.populate';
import 'table-to-json';
import 'devbridge-autocomplete';

import './modules/select2.custom.search';
import './modules/rush-fee-table';
import './modules/item-actions';
import '../core/initilizers/popovers.js';
import './custom-plugins/jquery-validate/jquery.validate.additional-methods.min';
import './custom-plugins/jquery-validate/jquery.validate.bootstrap';
import './custom-plugins/jquery-validate/jquery.validate.min';
import './custom-plugins/jquery-validate/jquery.validate.regex';
import './custom-plugins/jquery-ajax/jquery.ajax';
import './custom-plugins/date/dateTimePicker';
import './custom-plugins/bootstrap-btngroup/bootstrap-btngroup';
import './modules/inputToggle';

// the vue engine
import '../vue/app.js';

// new/converted scripts used in both legacy and new content
import '../core/index';
import '../UI/Products/product-status-manager';
import '../UI/Ordering/initialize-product-config-forms';

// plugin initializations
import './plugin-initializations';
import '../initializers/filestack-uploader';

// blade scripts
import './views/orders/item-edit-modal';
import './views/orders/shipping-cost';

// new crossover scripts
import '../utilities/masonry-grid';
import '../UI/zones/get-zone-cards';
import '../UI/Products/product-permissions';






 